export enum ActivityTypes {
  CAMP = 'CAMP',
  COMBAT = 'COMBAT',
  CONVERSATION = 'CONVERSATION',
  GATHER = 'GATHER',
  INN = 'INN',
  TRADE = 'TRADE',
}
